import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Material Cell Renderer for Total Necessity Component
 *
 * Displays material code and name in two lines
 */
@Component({
  selector: 'app-total-necessity-material-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-left">
      <span class="text-sm font-semibold text-gray-600 dark:text-gray-300">
        {{ code }}<br />
      </span>
      <span class="text-sm">{{ name }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class TotalNecessityMaterialCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get code(): string {
    return this.params?.data?.code ?? '-';
  }

  get name(): string {
    return this.params?.data?.name ?? '-';
  }
}
